import './index.css'
import App from './App'
import { createRoot } from 'react-dom/client'

if (process.env.REACT_APP_IS_HOME_TEST) {
    // @ts-ignore
    import('./custom_home_test.scss')
} else {
    // @ts-ignore
    import('./custom.scss')
}

const container = document.getElementById('app')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
